import { KitDeletionArea } from "@/components/KitDeletionArea";
import { Page, PageBody, PageHeader } from "@/components/app-layout";
import { AppTopRightMenu } from "@/components/app-layout/AppTopRightMenu";
import DisplayEditor from "@/components/display/display-editor/DisplayEditor";
import { GrantDialog } from "@/components/grant/GrantDialog";
import { ExportKitArea } from "@/components/kit/ExportKitArea";
import { KitDebugPageLink } from "@/components/kit/KitDebugPageLink";
import { LinkProjectTemplateArea } from "@/components/kit/LinkProjectTemplateArea";
import { Column } from "@/components/ui/flex";
import { Label } from "@/components/ui/label";
import { useKitData } from "@/data/use-kits-data";
import { useGroupUuid } from "@/hooks/use-group-uuid";
import { useKitUuid } from "@/hooks/use-kit-uuid";

export default function ProjectSettingsPage() {
  const groupUuid = useGroupUuid();
  const kitUuid = useKitUuid();

  const { kit, updateKit } = useKitData(groupUuid, kitUuid);

  if (!kit || !groupUuid) {
    return null;
  }

  const isHomeGroup = kit.group_uuid === groupUuid;

  return (
    <>
      {isHomeGroup && (
        <AppTopRightMenu.ContentPortal display="append">
          <GrantDialog
            groupUuid={groupUuid}
            objectName={kit.name}
            kitUuid={kit.uuid}
          />
        </AppTopRightMenu.ContentPortal>
      )}
      <Page>
        <PageHeader>
          <PageHeader.Title>Workbook Settings</PageHeader.Title>
        </PageHeader>
        <PageBody innerClassName="gap-8">
          {isHomeGroup ? (
            <DisplayEditor
              name={kit.name}
              description={kit.description}
              onNameChange={(name) => updateKit({ name })}
              onDescriptionChange={(description) => updateKit({ description })}
            />
          ) : (
            <Column className="gap-8">
              <Column className="gap-4">
                <Label>Name</Label>
                <div className="text-xl">{kit.name}</div>
              </Column>
              <Column className="gap-4">
                <Label>Description</Label>
                <div className="text-muted-foreground">
                  {kit.description || "No description"}
                </div>
              </Column>
            </Column>
          )}

          {isHomeGroup && (
            <LinkProjectTemplateArea kit={kit} updateKit={updateKit} />
          )}

          <ExportKitArea kit={kit} />
          <KitDeletionArea kit={kit} />
          <KitDebugPageLink />
        </PageBody>
      </Page>
    </>
  );
}
